import { FC } from 'react';
import styles from './BookBreadcrumbs.module.scss';
import Link from 'next/link';
import { parseISO, format } from 'date-fns';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

import { IBookDetailGenre } from '@/interfaces/bookDetail.interface';
import { IBookShortDetailGenre } from '@/interfaces/bookShortDetail.interface';

interface IBookBreadcrumbs {
  isBottom?: boolean;
  bookTitle: string;
  bookAlias: string;
  podcastTitle?: string;
  genres: IBookShortDetailGenre[];
  authorFullName: string;
  authorAlias?: string;
  createdAt: string;
  isPodcast?: boolean;
  isPodcastsItem?: boolean;
}

const BookBreadcrumbs: FC<IBookBreadcrumbs> = ({ isBottom, bookTitle, bookAlias, authorFullName, authorAlias, genres, createdAt, podcastTitle, isPodcast, isPodcastsItem }) => {
  const currentPath = String(useGetUrlPath());

  const isReadBookPageUrl = () => currentPath.includes('/read/');

  const getBookBreadcrumbs = () => {
    if (isPodcast) {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://kuchaknig.org/"},
          {"@type": "ListItem","position": 2,"name": "Подкасты","item": "https://kuchaknig.org/podcasts/"},
          {"@type": "ListItem","position": 3,"name": "${authorFullName}"},
          {"@type": "ListItem","position": 4,"name": "${bookTitle}"}
         ]
      }`,
      };
    } else {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://kuchaknig.org/"},
          {"@type": "ListItem","position": 2,"name": "📚${genres[0].title}","item": "https://kuchaknig.org/zhanr/${genres[0].alias}/"},
          {"@type": "ListItem","position": 3,"name": "${authorFullName}","item": "https://kuchaknig.org/avtor/${authorAlias}/"},
          {"@type": "ListItem","position": 4,"name": "${bookTitle}"}
         ]
      }`,
      };
    }
  };

  return (
    <>
      {!isBottom && !!genres.length && <script type="application/ld+json" dangerouslySetInnerHTML={getBookBreadcrumbs()} key="product-jsonld" />}
      <div className={`${styles.breadcrumbsListWrap} ${isBottom ? styles.breadcrumbsListWrap_bottom : ``}`}>
        <ul className={styles.breadcrumbsList}>
          <li className={styles.breadcrumbsList__item}>
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
              Главная
            </Link>
          </li>
          <li className={styles.breadcrumbsList__item}>
            📚
            {/* {genres.map((genre) => (
            <Link prefetch={false} key={genre.id} className={`${styles.breadcrumbsList__itemLink} ${styles.breadcrumbsList__itemLink_genre}`} href={`/zhanr/${genre.alias}`}>
              {genre.title}
            </Link>
          ))} */}
            {!!genres.length && !isPodcast && (
              <Link prefetch={false} className={`${styles.breadcrumbsList__itemLink} ${styles.breadcrumbsList__itemLink_genre}`} href={`/zhanr/${genres[0].alias}/`}>
                {genres[0].title}
              </Link>
            )}
            {!!isPodcast && (
              <Link prefetch={false} className={`${styles.breadcrumbsList__itemLink} ${styles.breadcrumbsList__itemLink_genre}`} href={`/podcasts/`}>
                Подкасты
              </Link>
            )}
          </li>
          <li className={styles.breadcrumbsList__item}>
            {authorAlias && authorAlias.length > 1 ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`/avtor/${authorAlias}/`}>
                {authorFullName}
              </Link>
            ) : (
              authorFullName
            )}
          </li>
          <li className={styles.breadcrumbsList__item}>
            {isReadBookPageUrl() ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`/avtor/${authorAlias}/${bookAlias}/`}>
                {bookTitle}
              </Link>
            ) : isPodcastsItem ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`/podcasts/${bookAlias}/`}>
                {bookTitle}
              </Link>
            ) : (
              bookTitle
            )}
          </li>
          {isPodcastsItem && <li className={styles.breadcrumbsList__item}>{podcastTitle}</li>}
        </ul>
        {isBottom ? (
          ''
        ) : (
          <div className={styles.bookInfoDate}>
            добавлено <time dateTime={createdAt}>{format(parseISO(createdAt), 'dd.MM.yyyy HH:mm')}</time>
          </div>
        )}
      </div>
    </>
  );
};

export default BookBreadcrumbs;
